import { graphqlShopifyStorefront } from "@repo/graphql-shopify-storefront";
// import { MailingAddress_Fragment } from "./mailingaddress";
// import { Metafield_Fragment } from "./metafield";
// import { Order_Fragment } from "./order";

export const Customer_Fragment = graphqlShopifyStorefront(
  `
  fragment Customer on Customer {
    acceptsMarketing
    addresses(first: 16) {
      nodes {
        ...MailingAddress
      }
    }
    createdAt
    dateOfBirth: metafield(namespace: "facts", key: "birth_date") {
      ...Metafield
    }
    defaultAddress {
      ...MailingAddress
    }
    displayName
    email
    firstName
    id
    lastName
    numberOfOrders
    orders(first: 16) {
      nodes {
        ...Order
      }
    }
    phone
    tags
    updatedAt
  }
`,
  // [MailingAddress_Fragment, Metafield_Fragment, Order_Fragment],
);
